var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"scroll-to-top",on:{"click":function($event){return _vm.scrollToTop()}}},[_c('img',{attrs:{"src":"/static/images/icon-top.svg","alt":"icone-ir-para-o-top"}})]):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }